export default class ShopItem{
    id;
    model;
    name;
    material;
    patternSelection;
    customLogo;
    customizationPrice;
    price;
    shippingPrice;
    kind;
    color;
    constructor(data){
        this.id = data.id;
        this.patternSelection = data.custom_pattern_available
        this.customLogo = data.custom_logo_available
        this.customizationPrice = data.customization_price
        this.price = data.price
        this.shippingPrice = data.shipping_price
        this.name = data.name
        this.model = data.model
        this.kind = data.kind
        this.material = data.material
        this.color = data.color
        this.data = data
    }
    
    get body(){
        return this.data
    }
}
